import { useState } from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

// TextField de senha com o "olho" para exibir/ocultar o valor. Mantém o
// slotProps de quem chama (ex.: startAdornment "Senha", autoComplete).
export default function PasswordField({ slotProps, ...props }) {
  const [visivel, setVisivel] = useState(false);

  return (
    <TextField
      {...props}
      type={visivel ? "text" : "password"}
      slotProps={{
        ...slotProps,
        input: {
          ...slotProps?.input,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                size="small"
                edge="end"
                aria-label={visivel ? "Ocultar senha" : "Mostrar senha"}
                onClick={() => setVisivel((v) => !v)}
                onMouseDown={(e) => e.preventDefault()}
              >
                {visivel ? (
                  <VisibilityOff fontSize="small" />
                ) : (
                  <Visibility fontSize="small" />
                )}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
}
